import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getMediaClientErrorReason, isRequestError } from '@atlaskit/media-client';
import { getFileStateErrorReason, ImageLoadError, isMediaFilePreviewError, isMediaFileStateError } from './errors';
export var getErrorTraceContext = function getErrorTraceContext(error) {
  if (isMediaFilePreviewError(error) && !!error.secondaryError) {
    if (isRequestError(error.secondaryError)) {
      var _error$secondaryError;
      return (_error$secondaryError = error.secondaryError.metadata) === null || _error$secondaryError === void 0 ? void 0 : _error$secondaryError.traceContext;
    } else if (isMediaFileStateError(error.secondaryError)) {
      var _error$secondaryError2;
      return (_error$secondaryError2 = error.secondaryError.details) === null || _error$secondaryError2 === void 0 || (_error$secondaryError2 = _error$secondaryError2.metadata) === null || _error$secondaryError2 === void 0 ? void 0 : _error$secondaryError2.traceContext;
    }
  }
};
export var getRenderErrorFailReason = function getRenderErrorFailReason(error) {
  if (isMediaFilePreviewError(error)) {
    return error.primaryReason;
  } else {
    return 'nativeError';
  }
};
export var getRenderErrorErrorReason = function getRenderErrorErrorReason(error) {
  if (isMediaFilePreviewError(error) && error.secondaryError) {
    var mediaClientReason = isMediaFileStateError(error.secondaryError) ? getFileStateErrorReason(error.secondaryError) : getMediaClientErrorReason(error.secondaryError);
    if (mediaClientReason !== 'unknown') {
      return mediaClientReason;
    }
  }
  return 'nativeError';
};
export var getRenderErrorErrorDetail = function getRenderErrorErrorDetail(error) {
  if (isMediaFilePreviewError(error) && error.secondaryError) {
    return error.secondaryError.message;
  } else {
    return error.message;
  }
};
export var extractErrorInfo = function extractErrorInfo(error, metadataTraceContext) {
  return {
    failReason: getRenderErrorFailReason(error),
    error: getRenderErrorErrorReason(error),
    errorDetail: getRenderErrorErrorDetail(error),
    metadataTraceContext: metadataTraceContext !== null && metadataTraceContext !== void 0 ? metadataTraceContext : getErrorTraceContext(error)
  };
};
export var createFailedSSRObject = function createFailedSSRObject(preview, metadataTraceContext) {
  return _objectSpread({
    status: 'fail'
  }, extractErrorInfo(new ImageLoadError(preview.source), metadataTraceContext));
};